import katex from 'katex';
import 'katex/dist/katex.min.css';

/**
 * Render LaTeX trong một chuỗi HTML/text.
 * Hỗ trợ:
 *   - Block math:   $$...$$ hoặc \[...\]
 *   - Inline math:  $...$   hoặc \(...\)
 *
 * Trả về HTML string với các công thức đã được render bằng KaTeX.
 */
export function renderLatex(input: string): string {
    if (!input) return input;

    let output = input;

    // 1. Block math: $$...$$
    output = output.replace(/\$\$([^$]+?)\$\$/gs, (_, math) => {
        try {
            return katex.renderToString(math.trim(), {
                displayMode: true,
                throwOnError: false,
                trust: true,
            });
        } catch {
            return `<span class="katex-error">$$${math}$$</span>`;
        }
    });

    // 2. Block math: \[...\]
    output = output.replace(/\\\[([^[\]]+?)\\\]/gs, (_, math) => {
        try {
            return katex.renderToString(math.trim(), {
                displayMode: true,
                throwOnError: false,
                trust: true,
            });
        } catch {
            return `<span class="katex-error">\\[${math}\\]</span>`;
        }
    });

    // 3. Inline math: $...$ (không phải $$)
    // Dùng regex cẩn thận để tránh match $$ đã xử lý ở trên
    output = output.replace(/\$([^$\n]+?)\$/g, (_, math) => {
        try {
            return katex.renderToString(math.trim(), {
                displayMode: false,
                throwOnError: false,
                trust: true,
            });
        } catch {
            return `<span class="katex-error">$${math}$</span>`;
        }
    });

    // 4. Inline math: \(...\)
    output = output.replace(/\\\(([^()]+?)\\\)/gs, (_, math) => {
        try {
            return katex.renderToString(math.trim(), {
                displayMode: false,
                throwOnError: false,
                trust: true,
            });
        } catch {
            return `<span class="katex-error">\\(${math}\\)</span>`;
        }
    });

    return output;
}

/**
 * Kiểm tra chuỗi có chứa LaTeX không
 */
export function hasLatex(input: string): boolean {
    if (!input) return false;
    return /\$[^$]|\$\$|\\\[|\\\(/.test(input);
}

